module.exports = __webpack_public_path__ + "media/images/common/visit_reserve/merit-phone-c6ad311502bac965615df89e72690c01.png";